import {
  Assessment,
  AssessmentResult,
  Candidate,
  Exam,
  ExamStatus,
} from '$synapse/models';

export interface ExamDTO {
  uuid: string;
  timeSpent: number;
  expirationDate?: Date;
  status: string;
  candidate: Candidate;
  completionDate?: Date;
  assessmentResults: AssessmentResult[];
  assessment: Assessment;
  totalAnsweredQuestions: number;
}

export function mapToExam(dto: ExamDTO): Exam {
  let status = ExamStatus[dto.status];
  return {
    ...dto,
    status: status,
    completionDate: dto.completionDate,
  };
}
